module.exports = __webpack_public_path__ + "static/img/md.20bf3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/md.png
// module id = oBR1
// module chunks = 53